import { useContext, useEffect, useRef, useState } from "react";
import {AppContext} from "../../../../AppProvider.jsx";
import { DeviceContext } from "../DeviceProvider.jsx";
import {billingMicroserviceUrl} from "../../../../../microservices/billing_microservice.js";
import {usersMicroserviceUrl} from "../../../../../microservices/users_microservice.js";
import "../../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/Device/Billing.css";
import { useReactToPrint } from "react-to-print";
import { useNavigate} from "react-router-dom";

const BillingDetails = ({showBillingDetails}) => {
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile,selectedDevice} = useContext(DeviceContext);
    const navigate = useNavigate();
    const [activeDeviceSubscription,setActiveDeviceSubscription] = useState(null);
    const [activeDeviceSubscriptionReceipt,setActiveDeviceSubscriptionReceipt] = useState(null);
    const [retrievingDeviceSubscriptionReceipt,setRetrievingDeviceSubscriptionReceipt] = useState(false);
    const [subscriptionHistory,setSubscriptionHistory] = useState(null);
    const [subscriptionPlans,setSubscriptionPlans] = useState(null);
    const [selectedSubscriptionPlan,setSelectedSubscriptionPlan] = useState(null);
    const [selectedSubscriptionPlanType,setSelectedSubscriptionPlanType] = useState('PREPAID');
    const [selectedBillingDetailsTab,setSelectedBillingDetailsTab] = useState('current-subscription');
    const [subscribingStatus,setSubscribingStatus] = useState('');
    const [billingAccounts,setBillingAccounts] = useState([]);
    const [billingAccountUserDetailsMap,setBillingAccountUserDetailsMap] = useState(null);
    const [showAccountNumbersBrowser,setShowAccountNumbersBrowser] = useState(false);
    const [selectedBillingAccount,setSelectedBillingAccount] = useState(null);
    const [customerKRAPIN,setCustomerKRAPIN] = useState('');
    const [customerName,setCustomerName] = useState('');
    const [receiptDisplayName,setReceiptDisplayName] = useState('ACCOUNT_NAMES');
    const receiptRef = useRef(null);
    
    const fetchBillingAccounts = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/accounts`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setBillingAccounts(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500) throw new Error(response.status);
        }
        catch(error){
            console.error(`An error occurred when processing the request: ${error}`)
        }
    };
    const fetchActiveDeviceSubscription = async() =>{
        try{
            if(!selectedDevice?.id) return;
            const url = `${billingMicroserviceUrl}/tenants/devices/${selectedDevice?.id}/subscriptions/active`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setActiveDeviceSubscription(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500)throw new Error(`response code: ${response.status}`);
            else setActiveDeviceSubscription('');
        }
        catch(error){
            console.error("An error occurred when fetching device's active subscription",error);
            setActiveDeviceSubscription('');
        }
    };
    const fetchDeviceAllSubscriptionPlans = async() =>{
        try{
            const url = `${billingMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/${selectedDevice?.id}/subscription/plans`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setSubscriptionPlans(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500)throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when fetching subscription plans',error);
        }
    };
    const fetchUser = async(userId) =>{
        try{
            const url = `${usersMicroserviceUrl}/tenants/customer-users/${userId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok) return await response.json();
            else throw new Error(`Error code: ${response.status}`)
        }
        catch(error){
            console.error('An error occurred when fetching user profile. ',error);
        }
    };
    const fetchActiveDeviceSubscriptionReceipt = async() =>{
        try{
            if(!selectedDevice?.id) return;
            setRetrievingDeviceSubscriptionReceipt(true);
            const url = `${billingMicroserviceUrl}/tenants/devices/${selectedDevice?.id}/subscriptions/${activeDeviceSubscription?.subscriptionId}/receipt`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok) setActiveDeviceSubscriptionReceipt(await response.json());
            else if(response.status === 401) logout();
            else if(response.status === 500)throw new Error(`response code: ${response.status}`);
            else setActiveDeviceSubscriptionReceipt('');
        }
        catch(error){
            console.error('An error occurred when retrieving active device subscription receipt',error);
        }
        setRetrievingDeviceSubscriptionReceipt(false);
    };
    const createNewDeviceSubscription = async() =>{
        try{
            if(selectedSubscriptionPlanType === 'PREPAID' && ((selectedSubscriptionPlan?.price * (1 + selectedSubscriptionPlan?.taxRate)) > selectedBillingAccount?.balance)){
                setSubscribingStatus('insufficient-balance');
                return;
            }
            const newDeviceSubscriptionPayload = selectedSubscriptionPlanType === 'PREPAID'?
            {
                deviceSubscriptionType:selectedSubscriptionPlanType,
                subscriptionPlanId:selectedSubscriptionPlan?.id,
                accountId:selectedBillingAccount?.accountId,
                customerKRAPIN:customerKRAPIN,
                customerName:customerName,
                receiptDisplayName:receiptDisplayName
            }:
            {
                deviceSubscriptionType:selectedSubscriptionPlanType,
                subscriptionPlanId:selectedSubscriptionPlan?.id
            };
            const url = `${billingMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/devices/${selectedDevice?.id}/subscriptions`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(newDeviceSubscriptionPayload)
            });
            if(response.ok){
                setActiveDeviceSubscription(await response.json());
                setSubscribingStatus('subscribed');
                return;
            }
            else if(response.status === 401) logout();
            else if(response.status === 402){
                setSubscribingStatus('insufficient-balance');
                return;
            }
            else if(response.status === 500) throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when creating a device subscription',error);
            setSubscribingStatus('subscription-error');
            return;
        }
        clearSubscribeDetails();
    };
    const proceedSubscriptionToolTip = () =>{
        if(selectedSubscriptionPlanType === 'POSTPAID') return '';
        else if(selectedBillingAccount) return '';
        else return 'Select billing account to proceed';
    };
    const formatGracePeriodDisplay = (gracePeriod) =>{
        const totalMs = Number(gracePeriod);
        const totalSeconds = Math.floor(totalMs / (1000));
        const days = Math.floor(totalSeconds / (3600 * 24));
        const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
        const minutes = Math.floor((totalSeconds - ((days * 3600 * 24) + (hours * 3600)))/60);
        const seconds = Math.max(0,Math.floor(totalSeconds - ((days * 3600 * 24) + (hours * 3600) + (minutes * 60))));
        if(days > 0) return `${days} day${days === 1? '':'s'}, ${hours} hour${hours === 1? '':'s'}, ${minutes} minute${minutes === 1? '':'s'}, ${seconds} second${seconds === 1? '':'s'}`;
        else if(hours > 0) return `${hours} hour${hours === 1? '':'s'}, ${minutes} minute${minutes === 1? '':'s'}, ${seconds} second${seconds === 1? '':'s'}`;
        else if(minutes > 0) return `${minutes} minute${minutes === 1? '':'s'}, ${seconds} second${seconds === 1? '':'s'}`;
        else return `${seconds} second${seconds === 1? '':'s'}`;
    };
    const clearSubscribeDetails = () =>{
        setSelectedBillingAccount(null);
        setSelectedSubscriptionPlan(null);
        setSubscribingStatus('');
    };
    const printReceipt = useReactToPrint({
        contentRef: receiptRef,
        documentTitle: `Receipt ${activeDeviceSubscriptionReceipt?.receiptNumber}`,
        pageStyle:
        ` @page { size: auto; margin: 10mm; }
            body {
                font-family: Arial, sans-serif;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
            }
            .tenant-administrator-device-current-subscription-receipt-container{
                margin-top: 2vh;
                padding: 0px 20px;
                padding-top: 15px;
                font-size: 14px;
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            }
            .tenant-administrator-device-current-subscription-receipt-container .company-details{
                padding-bottom: 2px;
                margin-bottom: 5px;
                border-bottom: 1px solid rgb(165, 165, 165);
            }
            .tenant-administrator-device-current-subscription-receipt-container .company-details p{
                margin: 2px 0px;
            }
            .tenant-administrator-device-current-subscription-receipt-container .customer-details{
                padding-bottom: 2px;
                margin-bottom: 5px;
                border-bottom: 1px solid rgb(165, 165, 165);
            }
            .tenant-administrator-device-current-subscription-receipt-container .customer-details p{
                margin: 2px;
            }
            .tenant-administrator-device-current-subscription-receipt-container .device-and-subscription-details{
                padding-bottom: 2px;
                margin-bottom: 5px;
                border-bottom: 1px solid rgb(165, 165, 165);
            }
            .tenant-administrator-device-current-subscription-receipt-container .device-and-subscription-details p{
                margin: 2px;
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container{
                padding-bottom: 2px;
                margin-bottom: 5px;
                border-bottom: 1px solid rgb(165, 165, 165);
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container h5{
                margin: 0px;
                font-weight: 500;
                font-size: 16px;
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container div{
                display: grid;
                grid-template-columns: 2.8fr 1fr;
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container p{
                margin: 2px;
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container p:nth-child(even){
                display: grid;
                grid-template-columns: 1fr 2fr;
            }
            .tenant-administrator-device-current-subscription-receipt-container .payment-breakdown-container p:nth-child(even) span{
                text-align: right;
            }
            .tenant-administrator-device-current-subscription-receipt-container .thank-you-note-p{
                text-align: center;
            }
            .tenant-administrator-device-current-subscription-receipt-container .kra-qr-code-container{
                text-align: center;
            }
            .tenant-administrator-device-current-subscription-receipt-container .kra-qr-code-container img{
                height: 200px;
            }
        `
    });
    useEffect(() =>{
        fetchActiveDeviceSubscription();
    },[showBillingDetails]);
    useEffect(() =>{
        if(!billingAccounts || !Array.isArray(billingAccounts)) return;
        const fetchBillingAccountsUserDetails = async() =>{
            const billingAccountUsers = await Promise.all(
                billingAccounts.map(async(billingAccount) => {
                    return {
                        accountId:billingAccount?.accountId,
                        user:await fetchUser(billingAccount?.userId)
                    }
                })
            );
            setBillingAccountUserDetailsMap(new Map(billingAccountUsers.map(({accountId,user}) => [accountId,user])));
        };
        fetchBillingAccountsUserDetails();
    },[billingAccounts]);
    useEffect(() =>{
        if(selectedBillingDetailsTab === 'subscription-plans'){
            fetchDeviceAllSubscriptionPlans();
            fetchBillingAccounts();
        }
    },[selectedBillingDetailsTab]);
    if(!showBillingDetails) return null;
    return(
    <div>
        <div className="tenant-device-device-subscription-header-container">
            <button className={selectedBillingDetailsTab === 'current-subscription'? ' active':''} onClick={() => setSelectedBillingDetailsTab('current-subscription')}>Current subscription</button>
            <button className={selectedBillingDetailsTab === 'subscription-history'? ' active':''} onClick={() => setSelectedBillingDetailsTab('subscription-history')}>Subscription history</button>
            <button className={selectedBillingDetailsTab === 'subscription-plans'? ' active':''} onClick={() => setSelectedBillingDetailsTab('subscription-plans')}>Explore plans</button>
        </div>
        <div>
            {selectedBillingDetailsTab === "current-subscription"?
            (
                <div className="tenant-administrator-device-current-subscription-container">
                    {activeDeviceSubscription === null?
                    (
                        <div className="tenant-administrator-device-current-subscription-loading-container">
                            <div></div>
                            <p>Loading current device subscription. Please wait...</p>
                        </div>
                    ):activeDeviceSubscription?
                    (
                        activeDeviceSubscriptionReceipt? 
                        (
                            <div className="tenant-administrator-device-current-subscription-receipt-parent-container">
                                <div ref={receiptRef} className="tenant-administrator-device-current-subscription-receipt-container">
                                    <div className="company-details">
                                        <p>{activeDeviceSubscriptionReceipt?.companyName}</p>
                                        <p>KRA PIN: {activeDeviceSubscriptionReceipt?.companyKRAPin}</p>
                                        <p>Receipt No: {activeDeviceSubscriptionReceipt?.receiptNumber}</p>
                                        <p>Date: {activeDeviceSubscriptionReceipt?.receiptDate}, {activeDeviceSubscriptionReceipt?.receiptTime}</p>
                                    </div>
                                    <div className="customer-details">
                                        <p>Account No: {activeDeviceSubscriptionReceipt?.customerAccountNumber}</p>
                                        <p>
                                            Name: {activeDeviceSubscriptionReceipt?.receiptDisplayName === 'ACCOUNT_NAMES'?
                                            (`${activeDeviceSubscriptionReceipt?.customerFirstName} ${activeDeviceSubscriptionReceipt?.customerLastName}`):
                                            `${activeDeviceSubscriptionReceipt?.customerName}`}
                                        </p>
                                        <p>Email: {activeDeviceSubscriptionReceipt?.customerEmail}</p>
                                        <p>KRA PIN: {activeDeviceSubscriptionReceipt?.customerKRAPin}</p>
                                    </div>
                                    <div className="device-and-subscription-details">
                                        <p>Device Name: {activeDeviceSubscriptionReceipt?.deviceName}</p>
                                        <p>Device ID: {activeDeviceSubscriptionReceipt?.deviceId}</p>
                                        <p>Subscription Plan: {activeDeviceSubscriptionReceipt?.subscriptionPlanName}(Prepaid)</p>
                                        <p>Duration: {activeDeviceSubscriptionReceipt?.durationType}</p>
                                        <p>Start date: {activeDeviceSubscriptionReceipt?.subscriptionStartDate} at {activeDeviceSubscriptionReceipt?.subscriptionStartTime}</p>
                                        <p>Expiry date: {activeDeviceSubscriptionReceipt?.subscriptionExpiryDate} at {activeDeviceSubscriptionReceipt?.subscriptionExpiryTime}</p>
                                    </div>
                                    <div className="payment-breakdown-container">
                                        <h5>Payment breakdown</h5>
                                        <div>
                                            <p>Subscription fee:</p>
                                            <p>KES 
                                                <span>
                                                    {Number(activeDeviceSubscriptionReceipt?.subscriptionFee || 0).toLocaleString('en-US',{
                                                    minimumFractionDigits:2,
                                                    maximumFractionDigits:2
                                                })}
                                                </span>
                                            </p>
                                            <p>Tax({Number(Number(activeDeviceSubscriptionReceipt?.taxRate || 0) * 100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:4})}%):</p>
                                            <p>KES
                                                <span>{Number(Number(activeDeviceSubscriptionReceipt?.subscriptionFee || 0) * Number(activeDeviceSubscriptionReceipt?.taxRate || 0)).toLocaleString('en-US',{
                                                    minimumFractionDigits:2,
                                                    maximumFractionDigits:2
                                                })}</span>
                                            </p>
                                            <p>Total charges:</p>
                                            <p>KES
                                                <span>{Number(Number(activeDeviceSubscriptionReceipt?.subscriptionFee || 0) * (1 + Number(activeDeviceSubscriptionReceipt?.taxRate || 0))).toLocaleString('en-US',{
                                                    minimumFractionDigits:2,
                                                    maximumFractionDigits:2
                                                })}</span>
                                            </p>
                                        </div>
                                    </div>
                                    {activeDeviceSubscriptionReceipt?.KRAQRCode?
                                        (
                                            <div className="kra-qr-code-container">
                                                <img src={`data:image/png;base64,${activeDeviceSubscriptionReceipt?.KRAQRCode}`}/>
                                            </div>
                                        ):(<></>)
                                    }
                                    <p className="thank-you-note-p">Thank you for doing business with us</p>
                                </div>
                                <div className="control-buttons-container">
                                    <button onClick={() => setActiveDeviceSubscriptionReceipt(null)}>Back</button>
                                    <button onClick={() =>{printReceipt()}}>Print receipt</button>
                                </div>
                            </div>
                        ):retrievingDeviceSubscriptionReceipt?
                        (
                            <div className="tenant-administrator-device-current-subscription-retrieving-receipt-container">
                                <div></div>
                                <p>Retrieving receipt. Please wait...</p>
                            </div>
                        ):
                        (
                            <div className="tenant-administrator-device-current-subscription-details-container">
                                <h3>Current device subscription</h3>
                                {activeDeviceSubscription?.deviceSubscriptionType === 'PREPAID'?
                                    (
                                        <div>
                                            <div className="subscription-plan-info-container">
                                                <h4>Plan info</h4>
                                                <div>
                                                    <span>Plan name:</span>{activeDeviceSubscription?.planName}
                                                </div>
                                                <div>
                                                    <span>Subscription type:</span>Prepaid
                                                </div>
                                            </div>
                                            <div className="subscription-pricing-container"
                                                style={{display:activeDeviceSubscription?.deviceSubscriptionType === 'POSTPAID'? 'none':'block'}}>
                                                <h4>Pricing</h4>
                                                <div>
                                                    <span>Price:</span>KES {Number(activeDeviceSubscription?.planPrice).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                                <div>
                                                    <span>Tax rate:</span>{Number(Number(activeDeviceSubscription?.planTaxRate) * 100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:4})}%
                                                </div>
                                                <div>
                                                    <span>Total price:</span>KES {Number(activeDeviceSubscription?.planTotalPrice).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                                <div>
                                                    <span>Amount paid:</span>KES {Number(activeDeviceSubscription?.amountPaid).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                                <div>
                                                    <span>Pending refund:</span>KES {Number(activeDeviceSubscription?.pendingRefund).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                            </div>
                                            <div className="subscription-status-container">
                                                <h4>Subscription status</h4>
                                                <div className={` ${activeDeviceSubscription?.status === 'ACTIVE'? 'active-status':activeDeviceSubscription?.staus === 'GRACE'? 'grace-status':'inactive-status'}`}>
                                                    <span>Status:</span>{activeDeviceSubscription?.status === 'ACTIVE'? 'Active':activeDeviceSubscription?.status === 'GRACE'? `Grace ${formatGracePeriodDisplay(activeDeviceSubscription?.remainingGracePeriod)}`:'Inactive'}
                                                </div>
                                                <div>
                                                    <span>Start date:</span>{activeDeviceSubscription?.startDate} at {activeDeviceSubscription?.startTime}
                                                </div>
                                                <div>
                                                    <span>Expiry date:</span>{activeDeviceSubscription?.deactivationDate} at {activeDeviceSubscription?.deactivationTime}
                                                </div>
                                            </div>
                                            <div className="cancel-subscription-button-container">
                                                <button
                                                    className="view-receipt-button"
                                                    style={{display:activeDeviceSubscription?.deviceSubscriptionType === 'PREPAID'? 'inline-block':'none'}}
                                                    onClick={async() =>{
                                                        await fetchActiveDeviceSubscriptionReceipt();
                                                    }}>View receipt</button>
                                                <button>Cancel subscription</button>
                                            </div>
                                        </div>
                                    ):(
                                        <div>
                                            <div className="subscription-plan-info-container">
                                                <h4>Plan info</h4>
                                                <div>
                                                    <span>Plan name:</span>{activeDeviceSubscription?.planName}
                                                </div>
                                                <div>
                                                    <span>Subscription type:</span>Postpaid
                                                </div>
                                            </div>
                                            <div className="subscription-pricing-container">
                                                <h4>Pricing</h4>
                                                <div>
                                                    <span>Price:</span>KES {Number(activeDeviceSubscription?.planPrice).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                                <div>
                                                    <span>Tax rate:</span>{Number(Number(activeDeviceSubscription?.planTaxRate) * 100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:4})}%
                                                </div>
                                                <div>
                                                    <span>Total price:</span>KES {Number(activeDeviceSubscription?.planTotalPrice).toLocaleString('en-US',{
                                                        minimumFractionDigits:2,
                                                        maximumFractionDigits:2
                                                    })}
                                                </div>
                                            </div>
                                            <div className="invoicing-container">
                                                <h4>Invoicing</h4>
                                                {activeDeviceSubscription?.invoice?
                                                    (
                                                        <div className="invoiced-container">
                                                            <p className="invoice-status-p">
                                                                <span>Status: </span> Invoiced
                                                            </p>
                                                            <p>
                                                                <span>Invoice NO:</span> {activeDeviceSubscription?.invoice?.invoiceNumber}
                                                            </p>
                                                            {activeDeviceSubscription?.invoice?.status === 'CREATED'?
                                                                (
                                                                    <div>
                                                                        <p style={{color:'darkorange'}}>INVOICE NOT ISSUED</p>
                                                                    </div>
                                                                ):
                                                                (
                                                                    <div>
                                                                        <p>
                                                                            <span>Start date:</span>{activeDeviceSubscription?.invoice?.startDate} at {activeDeviceSubscription?.invoice?.startTime}
                                                                        </p>
                                                                        <p>
                                                                            <span>Due date:</span>{activeDeviceSubscription?.invoice?.dueDate} at {activeDeviceSubscription?.invoice?.dueTime}
                                                                        </p>
                                                                    </div>
                                                                )
                                                            }
                                                            <div className="buttons-container">
                                                                <button onClick={() => navigate(`/tenants/invoices/${activeDeviceSubscription?.invoice?.id}`)}>View invoice</button>
                                                            </div>
                                                        </div>
                                                    ):(
                                                        <div className="uninvoiced-container">
                                                            <p className="invoice-status-p">
                                                                <span>Status: </span> Not invoiced
                                                            </p>
                                                            <div className="buttons-container">
                                                                <button onClick={() => navigate(`/tenants/invoices?create_new=true&&sub_id=${activeDeviceSubscription?.subscriptionId}`)}>Invoice subscription</button>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    ):
                    (
                        <div className="tenant-administrator-device-no-active-subscription-container">
                            <div>
                                <p>This device currently has no active subscription</p>
                                <p>Visit the <span onClick={() => setSelectedBillingDetailsTab('subscription-plans')}>Subscription market place</span> to add one</p>
                            </div>
                        </div>
                    )}
                </div>
            ):selectedBillingDetailsTab === "subscription-history"?
            (
                subscriptionHistory === null?
                (
                    <div className="tenant-administrator-device-subscription-history-loading-container">
                        <div></div>
                        <p>Loading subscription history. Please wait...</p>
                    </div>
                ):
                (
                    <div></div>
                )
            ):
            (<div>
                {selectedSubscriptionPlan? 
                (subscribingStatus === ''?
                    (
                        <div className="tenant-administrator-device-subscription-plans-subscribe-parent-container">
                            <div className={`tenant-administrator-device-subscription-plans-subscribe-container ${selectedSubscriptionPlanType === 'POSTPAID'? 'short':''}`}>
                                <p className="title-p">Choose your payment type</p>
                                <p className="description-p"><span>Prepay:</span>Pay upfront for the entire subscription</p>
                                <p className="description-p"><span>Postpay:</span>Pay at the end of each billing cycle.</p>
                                <div className="plan-type-container">
                                    <p>Plan type</p>
                                    <select
                                        value={selectedSubscriptionPlanType}
                                        onChange={(e) => setSelectedSubscriptionPlanType(e.target.value)}>
                                        <option value="PREPAID">Prepaid</option>
                                        <option value="POSTPAID">Postpaid</option>
                                    </select>
                                </div>
                                <div className={`account-number-entry-container ${selectedSubscriptionPlanType === 'POSTPAID'? 'hidden':''}`}>
                                    <p className="label-p">Account number</p>
                                    {selectedBillingAccount? (
                                        <div className="selected-account-number-display">
                                            <p>{selectedBillingAccount?.accountNumber}</p>
                                            <p
                                                className="close-icon"
                                                title="Remove selected"
                                                onClick={() => setSelectedBillingAccount(null)}>&#10006;</p>
                                        </div>
                                    ):(
                                        <input
                                            placeholder="Enter account number"
                                            onFocus={() => setShowAccountNumbersBrowser(true)}
                                            onBlur={() => setTimeout(() =>{
                                                setShowAccountNumbersBrowser(false);
                                            },200)}
                                        />
                                    )}
                                    <div className={`account-numbers-browser ${showAccountNumbersBrowser? 'active':''}`}>
                                        {billingAccounts.map((billingAccount) =>(
                                            <div key={billingAccount?.accountId} onClick={() => setSelectedBillingAccount(billingAccount)}>
                                                <p>
                                                    <span>{billingAccount?.accountNumber}</span>
                                                    <span className="email-address-span">{billingAccountUserDetailsMap?.get(billingAccount?.accountId)?.emailAddress}</span>
                                                </p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className={`kra-pin-entry-container ${selectedSubscriptionPlanType === 'POSTPAID'? 'hidden':''}`}>
                                    <p>KRA Pin</p>
                                    <input
                                        placeholder="Enter KRA PIN"
                                        value={customerKRAPIN}
                                        onChange={(e) => setCustomerKRAPIN(e.target.value)}
                                    />
                                </div>
                                <div className={`customer-name-container ${selectedSubscriptionPlanType === 'POSTPAID'? 'hidden':''}`}>
                                    <p>Customer Name</p>
                                    <input
                                        placeholder="Enter Customer Name"
                                        value={customerName}
                                        onChange={(e) => setCustomerName(e.target.value)}
                                    />
                                </div>
                                <div className={`receipt-display-container ${selectedSubscriptionPlanType === 'POSTPAID'? 'hidden':''}`}>
                                    <p>Receipt display</p>
                                    <select onChange={(e) => setReceiptDisplayName(e.target.value)} value={receiptDisplayName}>
                                        <option value="ACCOUNT_NAMES">Account Names</option>
                                        <option value="CUSTOMER_NAME">Customer Name</option>
                                    </select>
                                </div>
                                <div className="control-buttons-container">
                                    <button className="cancel" onClick={() => setSelectedSubscriptionPlan(null)}>
                                        Cancel
                                    </button>
                                    <button
                                        className={`proceed ${proceedSubscriptionToolTip() === ''? 'active':'inactive'}`}
                                        title={proceedSubscriptionToolTip()}
                                        onClick={async() =>{
                                            setSubscribingStatus('subscribing');
                                            await createNewDeviceSubscription();
                                        }}>Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    ):subscribingStatus === 'subscribing'?
                    (
                        <div className="tenant-administrator-device-subscription-plans-subscribe-processing-parent-container">
                            <div className="tenant-administrator-device-subscription-plans-subscribe-processing-container">
                                <div></div>
                                <p>Processing your subscription request...</p>
                            </div>
                        </div>
                    ):subscribingStatus === 'insufficient-balance'?
                    (
                        <div className="tenant-administrator-device-subscription-plans-subscribe-insufficient-balance-parent-container">
                            <div className="tenant-administrator-device-subscription-plans-subscribe-insufficient-balance-container">
                                <h4>Insufficient Balance</h4>
                                <p>The selected account has insufficient balance for this subscription.</p>
                                <p>Please top up and try again.</p>
                                <div>
                                    <button onClick={() =>{
                                        clearSubscribeDetails();
                                    }}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):subscribingStatus === 'subscription-error'?
                    (
                        <div className="tenant-administrator-device-subscription-plans-subscription-error-parent-container">
                            <div className="tenant-administrator-device-subscription-plans-subscription-error-container">
                                <h4>Subscription Error</h4>
                                <p>An error occurred while processing your subscription request.</p>
                                <div>
                                    <button onClick={() =>{
                                        clearSubscribeDetails();
                                    }}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):subscribingStatus === 'subscribed'?
                    (
                        <div className="tenant-administrator-device-subscription-plans-subscription-complete-parent-container">
                            <div className="tenant-administrator-device-subscription-plans-subscription-complete-container">
                                <h4>Subscription successful</h4>
                                <p>Thank you for subscribing. You can view your plan under the current subscription tab.</p>
                                <div>
                                    <button onClick={() =>{
                                        clearSubscribeDetails();
                                        setSelectedBillingDetailsTab('current-subscription');
                                    }}>Okay</button>
                                </div>
                            </div>
                        </div>
                    ):(<></>)
                ):subscriptionPlans === null?
                (
                    <div className="tenant-administrator-device-subscription-plans-loading-container">
                        <div></div>
                        <p>Loading subscription plans. Please wait...</p>
                    </div>
                ):subscriptionPlans === ''?
                (
                    <div>
                        <p>An error occurred when loading subscription plans</p>
                    </div>
                ):Array.isArray(subscriptionPlans) && subscriptionPlans.length === 0?
                (
                    <div className="tenant-administrator-device-subscription-plans-empty-parent-container">
                        <div className="tenant-administrator-device-subscription-plans-empty-container">
                            <p>There are no subscription plans available yet</p>
                        </div>
                    </div>
                ):
                (
                    <div className="tenant-administrator-device-subscription-plans-body-container">
                        {subscriptionPlans.map((subscriptionPlan) =>(
                            <div key={subscriptionPlan?.id} className="device-subscription-card">
                                <div className="title-container">{subscriptionPlan.name}</div>
                                <div className="price-container">
                                    <span className="currency-span">KES</span>
                                    <strong>
                                        {Number(subscriptionPlan.price).toLocaleString('en-US',{
                                            minimumFractionDigits:0,
                                            maximumFractionDigits:0
                                        })}
                                    </strong>
                                    <span>+ {Number(subscriptionPlan.taxRate * 100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2})}% VAT</span>
                                </div>
                                <div className="billing-cycle-container">
                                    Billing Cycle: <strong>{subscriptionPlan.duration}</strong>
                                </div>
                                <div className="features-container">
                                    {subscriptionPlan.features.map((feature,index) =>(
                                        <p key={index} className="feature"><span>✔</span>{feature}</p>
                                    ))}
                                </div>
                                <div className="subscribe-button-container">
                                    <button onClick={() => setSelectedSubscriptionPlan(subscriptionPlan)}>Subscribe</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )}
        </div>
    </div>
    );
};
export default BillingDetails;